export const FlujoEfectivoMensual = ({}) => {
    return(
        <table>
            <tr>
                <th colSpan={8}>MAQUINARIA DEL HUMAYA SA DE CV</th>
            </tr>
            <tr> 
                <th>NOMBRE DE LA EMPRESA</th>
                <th>NOMBRE DEL GERENTE</th>
                <th>FECHA DE ELABORACIÓN</th>
                <th>FECHA DE ÚLTIMA ACTUALIZACIÓN</th>
            </tr>
            <tr> 
                <th rowSpan={2}>ESTADO DE FLUJO DE EFECTIVO</th>
                <th>Arnoldo Reyes Rios</th>
                <th>7 de noviembre de 2023</th>
            </tr>
            <tr>
                <th>NOVIEMBRE</th>
                <th>DICIEMBRE</th>
                <th>ENERO</th>
                <th>FEBRERO</th>
                <th>MARZO</th>
                <th>ABRIL</th>
                <th>TOTALES</th>
            </tr>
            <tr>
                <th>INGRESO INICIAL DISPONIBLE EN BANCOS</th>
                <th>$ 2.215.000,00</th>
                <th>¡#REF!</th>
                <th>¡#REF!</th>
                <th>¡#REF!</th>
                <th>¡#REF!</th>
                <th>¡#REF!</th>
                <th>$ 2.215.000,00</th>
            </tr>
        </table>
    )
}